import { render, staticRenderFns } from "./page011.vue?vue&type=template&id=64bdcb4c&scoped=true&"
import script from "./page011.vue?vue&type=script&lang=js&"
export * from "./page011.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64bdcb4c",
  null
  
)

export default component.exports